import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../BitsStyles/Carouselpage.css';
import logo from '../BitsImages/logoooo12345.jpg';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about-us' },
  { label: 'Projects', to: '/projects' },
  { label: 'Careers', to: '/career-bits' },
  { label: 'Contact', to: '/contact-bits' },
];

const serviceLinks = [
  { label: 'Billing Solutions', to: '/billing', icon: 'bi-receipt-cutoff' },
  { label: 'IT Services', to: '/service-bits', icon: 'bi-display' },
  { label: 'Support Projects', to: '/service-bits', icon: 'bi-headset' },
];

const Careersnav = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropOpen, setDropOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropOpen(false);
  }, [location]);

  const isActive = (to) => location.pathname === to;

  return (
    <header className={`nav-header ${scrolled ? 'nav-scrolled' : ''}`}>
      <nav className="nav-inner">
        <Link to="/" className="nav-logo">
          <img src={logo} alt="BITS Logo" className="nav-logo-img" />
          <div className="nav-logo-text">
            <span className="nav-logo-main">Bellary</span>
            <span className="nav-logo-sub">Info Tech Solutions</span>
          </div>
        </Link>

        <div className="nav-links-desktop">
          {navLinks.filter(l => l.label !== 'Contact').map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`nav-link ${isActive(link.to) ? 'nav-link-active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          <div
            className="nav-dropdown-wrapper"
            onMouseEnter={() => setDropOpen(true)}
            onMouseLeave={() => setDropOpen(false)}
          >
            <button className={`nav-link nav-dropbtn ${location.pathname.includes('service') || location.pathname.includes('billing') ? 'nav-link-active' : ''}`}>
              Services
              <i className={`bi bi-chevron-down nav-chevron ${dropOpen ? 'open' : ''}`}></i>
            </button>
            <div className={`nav-dropdown ${dropOpen ? 'nav-dropdown-open' : ''}`}>
              {serviceLinks.map((s, i) => (
                <Link key={i} to={s.to} className="nav-dropdown-item">
                  <span className="nav-dropdown-icon"><i className={`bi ${s.icon}`}></i></span>
                  {s.label}
                </Link>
              ))}
            </div>
          </div>
          <Link to="/contact-bits" className={`nav-link ${isActive('/contact-bits') ? 'nav-link-active' : ''}`}>
            Contact
          </Link>
        </div>

        <div className="nav-right">
          <Link to="/contact-bits#contact-form" className="nav-cta">Get Started</Link>
          <button
            className={`nav-hamburger ${mobileOpen ? 'open' : ''}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>

      <div className={`nav-mobile ${mobileOpen ? 'nav-mobile-open' : ''}`}>
        <div className="nav-mobile-links">
          {navLinks.filter(l => l.label !== 'Contact').map(link => (
            <Link key={link.to} to={link.to} className={`nav-mobile-link ${isActive(link.to) ? 'active' : ''}`}>
              {link.label}
            </Link>
          ))}
          <div className="nav-mobile-group">
            <button className="nav-mobile-link nav-mobile-group-btn" onClick={() => setDropOpen(!dropOpen)}>
              Services
              <i className={`bi bi-chevron-down ${dropOpen ? 'open' : ''}`}></i>
            </button>
            {dropOpen && (
              <div className="nav-mobile-sub">
                {serviceLinks.map((s, i) => (
                  <Link key={i} to={s.to} className="nav-mobile-sublink">
                    <i className={`bi ${s.icon}`}></i> {s.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
          <Link to="/contact-bits" className={`nav-mobile-link ${isActive('/contact-bits') ? 'active' : ''}`}>
            Contact
          </Link>
          <Link to="/contact-bits#contact-form" className="nav-mobile-cta">
            Get Started <i className="bi bi-arrow-right"></i>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Careersnav;
